module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/62b1d36c102c00bd7277d734bb53d7e4.png";